/**
 * Returns true when the user only has a student/university licence.
 *
 * If they also have a purchased licence, they keep full access.
 *
 * Temporary until access is derived from package-to-content mapping.
 */
export function hasOnlyStudentLicenses(licenses: { ean: string }[] | null | undefined, eanStudentRestricted: readonly string[]): boolean {
  return !!eanStudentRestricted.length && !!licenses?.length && licenses.every(license => eanStudentRestricted.includes(license.ean))
}
